import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css";
import "swiper/css/autoplay";

import images from "./image-data";
import DecorativeStripeFull from '../web_elements/decorative_stripe_full.png';
import MoreInfo from "./MoreInfo";
const ImageSlider = () => {
    return (
        <div>
            <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={1} // Space between slides
                slidesPerView={2} // Display one slide at a time
                onSwiper={(swiper) => console.log(swiper)}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }} // Auto slide every 3 seconds

            >
                {images.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div style={{textAlign: "center"}}>
                            <img
                                src={item.image}
                                alt={`Slide ${index + 1}`}
                                style={{
                                    maxWidth: "45vw",
                                    height: "auto",
                                    borderRadius: "21px",
                                    objectFit: "contain",
                                    filter: "drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.5))",
                                }}

                            />
                            <p className="slideshow-text" style={{
                                fontSize: "2.8vw",
                                color: "white",
                                fontFamily: "DIN Condensed",
                            }}>
                                {item.subtitle}
                            </p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default ImageSlider;
